import React, { useState } from 'react';
import { Divider, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SubjectiveSection from '../CollapsibleSections/SubjectiveSection/SubjectiveSection';
import ObjectiveSection from '../CollapsibleSections/ObjectiveSection/ObjectiveSection';
import AssessmentSection from '../CollapsibleSections/AssessmentSection/AssessmentSection';
import ServicesProvidedSection from '../CollapsibleSections/ServicesProvided/ServicesProvidedSection';
import PlanSection from '../CollapsibleSections/PlanSection/PlanSection';
import styles from '../styles.module.scss';

type Props = {
  consultationForm: any;
  setConsultationForm: React.Dispatch<React.SetStateAction<any>>;
  thisCase: any;
  setCase: React.Dispatch<React.SetStateAction<any>>;
  userInfo: any;
  register: any;
  setValue: any;
  getValues: any;
  trigger: any;
  errors: any;
  control: any;
  addRequiredField: boolean;
  setAddRequiredField: React.Dispatch<React.SetStateAction<boolean>>;
  journeyPaused?: boolean;
  journeyAtLimit?: boolean;
};

const SoapNotesCard = ({
  consultationForm,
  setConsultationForm,
  thisCase,
  setCase,
  userInfo,
  register,
  setValue,
  getValues,
  trigger,
  errors,
  control,
  addRequiredField,
  setAddRequiredField,
  journeyPaused = false,
  journeyAtLimit = false,
}: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className={styles.consultationPageRightSideFrameCaseDetails}>
      <div
        className={styles.consultationPageRightSideFrameCaseDetailsTitle}
        onClick={handleToggle}
        role="button"
      >
        <div className={styles.consultationPageRightSideFrameCaseDetailsTitleDiv}>
          <span>SOAP notes</span>

          <IconButton size="small">
            <KeyboardArrowDownIcon
              style={{
                transition: '0.25s',
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
            />
          </IconButton>
        </div>

        <Divider orientation="horizontal" flexItem className={styles.divider} />
      </div>

      {isOpen && (
        <>
          <SubjectiveSection
            consultationForm={consultationForm}
            setConsultationForm={setConsultationForm}
            thisCase={thisCase}
            setCase={setCase}
            userInfo={userInfo}
            register={register}
            setValue={setValue}
            trigger={trigger}
            errors={errors}
          />

          <ObjectiveSection
            consultationForm={consultationForm}
            setConsultationForm={setConsultationForm}
            thisCase={thisCase}
            setCase={setCase}
            userInfo={userInfo}
            register={register}
            setValue={setValue}
            trigger={trigger}
            errors={errors}
            control={control}
          />

          <AssessmentSection
            consultationForm={consultationForm}
            setConsultationForm={setConsultationForm}
            thisCase={thisCase}
            setCase={setCase}
            userInfo={userInfo}
            register={register}
            setValue={setValue}
            getValues={getValues}
            errors={errors}
          />

          <ServicesProvidedSection
            consultationForm={consultationForm}
            setConsultationForm={setConsultationForm}
            thisCase={thisCase}
            setCase={setCase}
            userInfo={userInfo}
            register={register}
            setValue={setValue}
            getValues={getValues}
            trigger={trigger}
            errors={errors}
          />

          <PlanSection
            consultationForm={consultationForm}
            setConsultationForm={setConsultationForm}
            thisCase={thisCase}
            setCase={setCase}
            userInfo={userInfo}
            register={register}
            setValue={setValue}
            trigger={trigger}
            errors={errors}
            addRequiredField={addRequiredField}
            setAddRequiredField={setAddRequiredField}
            journeyPaused={journeyPaused}
            journeyAtLimit={journeyAtLimit}
          />
        </>
      )}
    </div>
  );
};

export default SoapNotesCard;